import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

/**
 * 서비스 카드 — 홈 `codam-service-box`와 동일하게 배경 그라데이션 + 일러스트 레이어
 * (`public/assets/img/services/service_image_*.png`, 카드별 `thumb3dSrc` 가능)
 */
const featuresContent = [
    {
        thumb3d: 1,
        thumb3dSrc: '/assets/img/services/saas-platform.png',
        tone: 'saas',
        chips: ['구독형 플랫폼', '테넌트 분리'],
        title: 'SaaS 플랫폼 개발',
        desc: '멀티테넌트 구조, 구독 관리, API 개방성을 고려한 B2B SaaS 플랫폼을 처음부터 함께 설계하고 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '',
    },
    {
        thumb3d: 3,
        thumb3dSrc: '/assets/img/services/admin-system.png',
        tone: 'admin',
        chips: ['관리자 화면', '권한·모니터링'],
        title: '관리자 시스템 구축',
        desc: '복잡한 권한 구조, 대용량 데이터 처리, 실시간 모니터링이 가능한 기업용 어드민 시스템을 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '100',
    },
    {
        thumb3d: 2,
        thumb3dSrc: '/assets/img/services/api-backend.png',
        tone: 'api',
        chips: ['연동·설계', '고가용성'],
        title: 'API 및 백엔드 개발',
        desc: '안정적인 API 설계, 마이크로서비스 아키텍처, 높은 트래픽 처리를 위한 확장 가능한 백엔드를 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '150',
    },
    {
        thumb3d: 1,
        thumb3dSrc: '/assets/img/services/erp-integration.png',
        tone: 'erp',
        chips: ['패키지 연동', '기존 시스템'],
        title: 'ERP / 그룹웨어 연동',
        desc: 'SAP, Oracle ERP, 영림원, 더존 등 기업 내 레거시 시스템과 신규 플랫폼의 안정적인 연동을 지원합니다.',
        dataAos: 'fade-up',
        dataDelay: '200',
    },
    {
        thumb3d: 2,
        thumb3dSrc: '/assets/img/services/data-business-system.png',
        tone: 'data',
        chips: ['수집·분석', '시각화·의사결정'],
        title: '데이터 기반 업무 시스템',
        desc: '실시간 데이터 수집, 분석, 시각화까지 데이터 기반 의사결정을 지원하는 통합 비즈니스 인텔리전스 시스템을 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '250',
    },
    {
        thumb3d: 5,
        thumb3dSrc: '/assets/img/services/maintenance-performance.png',
        tone: 'ops',
        chips: ['성능 분석·개선', '클라우드 전환'],
        title: '유지보수 및 성능 개선',
        desc: '기존 레거시 시스템의 성능 병목 분석, 코드 리팩토링, 클라우드 마이그레이션으로 시스템 수명을 연장합니다.',
        dataAos: 'fade-up',
        dataDelay: '300',
    },
    {
        thumb3d: 4,
        thumb3dSrc: '/assets/img/services/character-design.png',
        tone: 'creative',
        chips: ['브랜드 IP', '가이드·활용'],
        title: '캐릭터 디자인',
        anchorId: 'design-character',
        desc: '브랜드·IP에 맞는 마스코트와 일러스트, 표정·포즈 변형, 활용 가이드까지 디지털·인쇄 채널에 일관되게 쓰이는 캐릭터 자산을 기획·제작합니다.',
        dataAos: 'fade-up',
        dataDelay: '350',
    },
    {
        thumb3d: 2,
        thumb3dSrc: '/assets/img/services/industrial-design.png',
        tone: 'manufacture',
        chips: ['장비·제품 형태', '색·재질·마감'],
        title: '산업 디자인',
        anchorId: 'design-industrial',
        desc: '제조 공정·인체공학·내구성을 고려한 산업용 장비·제품의 외형, 조작부, CMF(색·재질·마감)를 설계해 현장 사용성과 브랜드 이미지를 동시에 높입니다.',
        dataAos: 'fade-up',
        dataDelay: '400',
    },
    {
        thumb3d: 5,
        thumb3dSrc: '/assets/img/services/product-design.png',
        tone: 'product-ui',
        chips: ['사용자 경험', '시제품·양산 연계'],
        title: '제품 디자인',
        anchorId: 'design-product',
        desc: '사용자 니즈와 시장 포지셔닝을 바탕으로 컨셉 스케치, 3D 목업, 프로토타입까지 이어지는 제품 경험을 설계하고, 양산·마케팅과 연결되는 디자인 산출물을 제공합니다.',
        dataAos: 'fade-up',
        dataDelay: '450',
    },
]

/** 서비스 페이지 등에서 그대로 재사용할 전체 카드 목록 */
export const FEATURE_FOUR_DEFAULT_ITEMS = featuresContent

const FeatureFour = (props = {}) => {
    const { items } = props
    const list = items ?? featuresContent
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {list.map((val, i) => {
                    const imageSrc = val.thumb3dSrc || `/assets/img/services/service_image_${val.thumb3d}.png`
                    return (
                        <div
                            key={val.anchorId || i}
                            id={val.anchorId}
                            className="col-lg-4 col-md-6"
                            data-aos={val.dataAos}
                            data-aos-delay={val.dataDelay}
                        >
                            <div className={`codam-service-box codam-service-box--${val.tone} mb-30`}>
                                <div className="codam-service-box__image-wrap" aria-hidden="true">
                                    <img className="codam-service-box__image" src={imageSrc} alt="" loading="lazy" />
                                </div>
                                <div className="codam-service-box__body">
                                    <h3 className="codam-service-box__title">
                                        <Link to="/services-details">{val.title}</Link>
                                    </h3>
                                    <p className="codam-service-box__desc">{val.desc}</p>
                                </div>
                                <div className="codam-service-box__footer">
                                    <Link
                                        className="codam-service-box__arrow"
                                        to="/services-details"
                                        aria-label={`${val.title} 자세히 보기`}
                                    >
                                        <i className="bi bi-arrow-up-right" />
                                    </Link>
                                    <div className="codam-service-box__chips">
                                        {val.chips.map((chip) => (
                                            <span key={chip} className="codam-service-box__chip">
                                                {chip}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </Fragment>
    )
}

export default FeatureFour
